var _style, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomepageIllustration(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 750 500",
    style: {
      enableBackground: "new 0 0 750 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{fill:#CCCFDD;}\n\t.st2{fill:#4F5B6C;}\n\t.st3{fill:#928AD4;}\n\t.st4{fill:#ECE9FF;}\n\t.st5{fill:#FFFFFF;}\n\t.st6{opacity:0.57;fill:#958CD9;enable-background:new    ;}\n\t.st7{fill:#C0BAF2;}\n\t.st8{fill:#958CD9;}\n\t.st9{fill:none;stroke:#78AB7E;stroke-width:0.8534;stroke-miterlimit:10;}\n\t.st10{fill:#FCDEAD;}\n\t.st11{fill:#126F48;}\n\t.st12{opacity:0.39;fill:none;stroke:#958CD9;stroke-width:0.9229;stroke-miterlimit:10;enable-background:new    ;}\n\t.st13{fill:#131B3B;}\n\t.st14{fill:#3CAB6F;}\n\t.st15{fill:#6A4219;}\n\t.st16{fill:#3228AC;}\n\t.st17{fill:none;stroke:#EBE8FF;stroke-width:0.438;stroke-miterlimit:10;}\n\t.st18{opacity:0.34;fill:#1FDA55;enable-background:new    ;}\n\t.st19{fill:none;stroke:#3E465C;stroke-width:0.5242;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st20{fill:none;stroke:#3E465C;stroke-width:0.482;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st21{fill:#51505E;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BACKGROUND"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M93.4,449.9H652c0-0.1,0.1-0.1,0.1-0.1c10.7-13.6,26.6-47.4,30.4-63.7c9.7-42.4,21.4-108-62.7-165.7 c-48.3-33.2-50.2-84.8-98.8-139.2c-55.7-62.3-201.7-66.3-256.6,23c-37.6,61.1-23.6,85.2-113.8,123.9 c-57.6,24.4-105.8,84.3-91,159.2C64.6,412.4,77.2,432.4,93.4,449.9z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M637.8,449.9c0,3.7-121.2,6.7-270.6,6.7s-270.6-3-270.6-6.7s121.2-6.7,270.6-6.7S637.8,446.2,637.8,449.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "447.5,446.7 481.9,287.4 475.2,287.4 440.8,446.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "491.7,446.7 526.1,287.4 519.4,287.4 485,446.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "516.1,318.2 471.9,318.2 473,313.3 517.2,313.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "508.7,352.5 464.5,352.5 465.6,347.5 509.8,347.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "501.3,386.8 457.1,386.8 458.1,381.8 502.3,381.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "493.9,421.1 449.6,421.1 450.7,416.1 494.9,416.1  "
  })), /*#__PURE__*/React.createElement("rect", {
    x: 475.8,
    y: 287.5,
    className: "st3",
    width: 50.3,
    height: 3.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "568.8,446.7 518.6,287.4 525.3,287.4 575.5,446.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "524.6,446.7 474.4,287.4 481.1,287.4 531.3,446.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "487.4,318.2 531.6,318.2 530.1,313.3 485.9,313.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "498.3,352.5 542.5,352.5 540.9,347.5 496.7,347.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "509.1,386.8 553.3,386.8 551.7,381.8 507.5,381.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "519.9,421.1 564.1,421.1 562.5,416.1 518.3,416.1  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M189.6,445.6h-23.1c-3.1,0-5.6-2.5-5.6-5.6v-13h34.3v13C195.3,443.1,192.7,445.6,189.6,445.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M340.4,445.6h-23.1c-3.1,0-5.6-2.5-5.6-5.6v-13H346v13C346,443.1,343.5,445.6,340.4,445.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 160.9,
    y: 427,
    className: "st1",
    width: 34.3,
    height: 9.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 311.7,
    y: 427,
    className: "st1",
    width: 34.3,
    height: 9.7
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M415.3,320.2h-16.9v-48.8h16.9c2.1,0,3.7,1.7,3.7,3.7v41.4C419,318.5,417.4,320.2,415.3,320.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M407.4,360.1h-8.9v-13.2h8.9c2.1,0,3.7,1.7,3.7,3.7v5.7C411.1,358.4,409.4,360.1,407.4,360.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M407.4,382.3h-8.9v-13.2h8.9c2.1,0,3.7,1.7,3.7,3.7v5.7C411.1,380.6,409.4,382.3,407.4,382.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M393.1,431.7H126.5c-5.8,0-10.5-4.7-10.5-10.5V242.7c0-5.8,4.7-10.5,10.5-10.5h266.6 c5.8,0,10.5,4.7,10.5,10.5v178.6C403.6,427,398.9,431.7,393.1,431.7z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 212.5,
    cy: 332.6,
    r: 76.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -172.9517 247.6759)",
    className: "st2",
    cx: 212.5,
    cy: 332.6,
    rx: 70.8,
    ry: 70.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M272,328.6c-0.1-0.5-0.3-1-0.4-1.4c-3-7.8-10.2-0.2-14.6,2.9c-6.6,4.6-14.4,2.3-21.1-0.6 c-4.5-2-7.9-1.7-9.3-1.4c-0.5-1.5-1.2-3-2.1-4.3c7.4-3,16.2-5.2,19.9-12.3c9.8-19.4-15.9-40.8-34.3-36c-0.5,0.1-1,0.3-1.4,0.4 c-7.8,3-0.2,10.2,2.9,14.6c4.6,6.6,2.3,14.4-0.6,21.1c-1.2,2.6-1.5,4.9-1.6,6.6c-1.8,0.5-3.5,1.3-5.1,2.4 c-2.6-6.8-5-14.2-11.4-17.4c-19.4-9.8-40.8,15.9-36,34.3c0.1,0.5,0.3,1,0.4,1.4c3,7.8,10.2,0.2,14.6-2.9 c6.6-4.6,14.4-2.3,21.1,0.6c2.7,1.2,5,1.6,6.7,1.6c0.8,1.7,2,3.3,3.4,4.6c-7.1,2.7-15.2,5.1-18.6,11.8 c-9.8,19.4,15.9,40.8,34.3,36c0.5-0.1,1-0.3,1.4-0.4c7.8-3,0.2-10.2-2.9-14.6c-4.6-6.6-2.3-14.4,0.6-21.1 c2.1-4.8,1.6-8.3,1.3-9.6c1.5-0.7,2.8-1.7,3.9-2.9c3.2,7.5,5.3,17.2,12.8,21C255.3,372.7,276.8,346.9,272,328.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M243.2,356c-8.9-1.8-13.5-11.8-19.2-18.3v-12.3c0,0,3.5-2.5,10.1-1.6c7.2,1,15.3,1.1,20.5-5.1 c3.5-4.2,8.3-13.5,13.3-6.8c0.3,0.4,0.5,0.8,0.8,1.2C278.2,329.6,264.5,360.2,243.2,356z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M224,329.1v-3.6c0,0,3.5-2.5,10.1-1.6c7.2,1,15.3,1.1,20.5-5.1c3.5-4.2,8.3-13.5,13.3-6.8 c-4.9,0.9-6.9,2.3-8.7,10.9c-2.3,10.6-7.9,15.7-16,16.4C236.9,339.8,230,337.3,224,329.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M185.6,310c8.9,1.8,13.5,11.8,19.2,18.3v12.3c0,0-3.5,2.5-10.1,1.6c-7.2-1-15.3-1.1-20.5,5.1 c-3.5,4.2-8.3,13.5-13.3,6.8c-0.3-0.4-0.5-0.8-0.8-1.2C150.6,336.4,164.3,305.8,185.6,310z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M204.8,336.9v3.6c0,0-3.5,2.5-10.1,1.6c-7.2-1-15.3-1.1-20.5,5.1c-3.5,4.2-8.3,13.5-13.3,6.8 c4.9-0.9,6.9-2.3,8.7-10.9c2.3-10.6,7.9-15.7,16-16.4C191.8,326.2,198.7,328.7,204.8,336.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M237.3,304.2c-1.8,8.9-11.8,13.5-18.3,19.2h-12.3c0,0-2.5-3.5-1.6-10.1c1-7.2,1.1-15.3-5.1-20.5 c-4.2-3.5-13.5-8.3-6.8-13.3c0.4-0.3,0.8-0.5,1.2-0.8C211,269.2,241.6,282.9,237.3,304.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M210.4,323.4h-3.6c0,0-2.5-3.5-1.6-10.1c1-7.2,1.1-15.3-5.1-20.5c-4.2-3.5-13.5-8.3-6.8-13.3 c0.9,4.9,2.3,6.9,10.9,8.7c10.6,2.3,15.7,7.9,16.4,16C221.2,310.4,218.7,317.3,210.4,323.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M191.4,361.8c1.8-8.9,11.8-13.5,18.3-19.2H222c0,0,2.5,3.5,1.6,10.1c-1,7.2-1.1,15.3,5.1,20.5 c4.2,3.5,13.5,8.3,6.8,13.3c-0.4,0.3-0.8,0.5-1.2,0.8C217.7,396.8,187.2,383.1,191.4,361.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M218.3,342.6h3.6c0,0,2.5,3.5,1.6,10.1c-1,7.2-1.1,15.3,5.1,20.5c4.2,3.5,13.5,8.3,6.8,13.3 c-0.9-4.9-2.3-6.9-10.9-8.7c-10.6-2.3-15.7-7.9-16.4-16C207.6,355.6,210.1,348.7,218.3,342.6z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1615 -0.9869 0.9869 0.1615 -150.0701 488.6715)",
    className: "st8",
    cx: 212.5,
    cy: 332.6,
    rx: 14.3,
    ry: 14.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 133.6,
    y: 252.2,
    className: "st9",
    width: 161.7,
    height: 161.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 159.6,
    y1: 252.2,
    x2: 159.6,
    y2: 413.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 195.3,
    y1: 252.2,
    x2: 195.3,
    y2: 413.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 230.9,
    y1: 252.2,
    x2: 230.9,
    y2: 413.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 266.5,
    y1: 252.2,
    x2: 266.5,
    y2: 413.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 133.6,
    y1: 258.6,
    x2: 295.2,
    y2: 258.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 133.6,
    y1: 276,
    x2: 295.2,
    y2: 276
  }), /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 133.6,
    y1: 293.5,
    x2: 295.2,
    y2: 293.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 133.6,
    y1: 310.9,
    x2: 295.2,
    y2: 310.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 133.6,
    y1: 328.3,
    x2: 295.2,
    y2: 328.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 133.6,
    y1: 345.7,
    x2: 295.2,
    y2: 345.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 133.6,
    y1: 363.1,
    x2: 295.2,
    y2: 363.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 133.6,
    y1: 380.5,
    x2: 295.2,
    y2: 380.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 133.6,
    y1: 397.9,
    x2: 295.2,
    y2: 397.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 133.6,
    y1: 267.3,
    x2: 295.2,
    y2: 267.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 133.6,
    y1: 284.7,
    x2: 295.2,
    y2: 284.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 133.6,
    y1: 302.1,
    x2: 295.2,
    y2: 302.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 133.6,
    y1: 319.5,
    x2: 295.2,
    y2: 319.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 133.6,
    y1: 336.9,
    x2: 295.2,
    y2: 336.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 133.6,
    y1: 354.3,
    x2: 295.2,
    y2: 354.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 133.6,
    y1: 371.8,
    x2: 295.2,
    y2: 371.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 133.6,
    y1: 389.2,
    x2: 295.2,
    y2: 389.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 133.6,
    y1: 406.6,
    x2: 295.2,
    y2: 406.6
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M364.1,416.6h-39.9c-2.5,0-4.5-2-4.5-4.5v-72.8c0-2.5,2-4.5,4.5-4.5h39.9c2.5,0,4.5,2,4.5,4.5v72.8 C368.6,414.6,366.6,416.6,364.1,416.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M364.1,264h-39.9c-2.5,0-4.5-2-4.5-4.5v-7.4c0-2.5,2-4.5,4.5-4.5h39.9c2.5,0,4.5,2,4.5,4.5v7.4 C368.6,262,366.6,264,364.1,264z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M364.1,287.7h-39.9c-2.5,0-4.5-2-4.5-4.5v-7.4c0-2.5,2-4.5,4.5-4.5h39.9c2.5,0,4.5,2,4.5,4.5v7.4 C368.6,285.7,366.6,287.7,364.1,287.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M364.1,311.4h-39.9c-2.5,0-4.5-2-4.5-4.5v-7.4c0-2.5,2-4.5,4.5-4.5h39.9c2.5,0,4.5,2,4.5,4.5v7.4 C368.6,309.4,366.6,311.4,364.1,311.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M129.1,247c0,1.4-1.1,2.5-2.5,2.5c-1.4,0-2.5-1.1-2.5-2.5s1.1-2.5,2.5-2.5 C128,244.6,129.1,245.7,129.1,247z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M129.1,417.6c0,1.4-1.1,2.5-2.5,2.5c-1.4,0-2.5-1.1-2.5-2.5s1.1-2.5,2.5-2.5 C128,415.1,129.1,416.3,129.1,417.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M393.1,247c0,1.4-1.1,2.5-2.5,2.5s-2.5-1.1-2.5-2.5s1.1-2.5,2.5-2.5S393.1,245.7,393.1,247z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M393.1,417.6c0,1.4-1.1,2.5-2.5,2.5s-2.5-1.1-2.5-2.5s1.1-2.5,2.5-2.5S393.1,416.3,393.1,417.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M358.2,346.9H331c-1.2,0-2.2-1-2.2-2.2l0,0c0-1.2,1-2.2,2.2-2.2h27.1c1.2,0,2.2,1,2.2,2.2l0,0 C360.3,345.9,359.4,346.9,358.2,346.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M358.2,358.5H331c-1.2,0-2.2-1-2.2-2.2l0,0c0-1.2,1-2.2,2.2-2.2h27.1c1.2,0,2.2,1,2.2,2.2l0,0 C360.3,357.5,359.4,358.5,358.2,358.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M358.2,370.1H331c-1.2,0-2.2-1-2.2-2.2l0,0c0-1.2,1-2.2,2.2-2.2h27.1c1.2,0,2.2,1,2.2,2.2l0,0 C360.3,369.2,359.4,370.1,358.2,370.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M493.4,138c0,0-2.3-5.5-2.8-6.6s-3.4-4.7-4.3-5.3c-1-0.6-5.3-1.8-5.4-1.6c-0.1,0.3-0.1,1.7,0.1,2.1 s0.5,1,0.5,3.3c0,2.2-0.5,4.1,0.7,5.5s1.7,2.1,3.4,2.9c1.7,0.8,3.4,2.7,3.5,3L493.4,138z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M555.3,178.3c0,0,4.8,31.1-8.8,20.2c-8.5-6.8-35.2-28.2-35.2-28.2l-25.6-30.6c0,0,3.9-3.9,7.4-4l27.4,24.1 C520.6,159.9,554.1,173.3,555.3,178.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M503.7,131.6l-3.8-8.1c-1-2.2-3.3-3.7-5.7-3.7h-213c-2.5,0-4.7,1.4-5.7,3.7l-3.8,8.1l-1.8,48.3l5.8,20.5 c0.8,2.9,3.5,4.9,6.4,4.9h211.1c3,0,5.6-2,6.4-4.9l5.8-20.5L503.7,131.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M500.5,170.4H264.9l5.8,20.5c0.8,2.9,3.5,4.9,6.4,4.9h211.1c3,0,5.6-2,6.4-4.9L500.5,170.4z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "500.5,170.4 264.9,170.4 266.7,122.1 498.7,122.1  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M489.2,110.3h-213c-2.5,0-4.7,1.4-5.7,3.7l-3.8,8.1h232l-3.8-8.1C493.9,111.7,491.6,110.3,489.2,110.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M280.1,151l-0.2,4.9c-0.1,1.7,1.3,3.1,3,3.1h199.6c1.7,0,3-1.4,3-3.1l-0.2-4.9H280.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "482.6,190.3 282.7,190.3 279,177.1 486.3,177.1  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "480.9,182.4 283.1,182.4 282.3,179.6 481.8,179.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "480,185.5 284.1,185.5 283.4,183.5 480.6,183.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "479.3,187.6 284.7,187.6 284.3,186.3 479.7,186.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "478.9,188.8 285.1,188.8 284.9,188.2 479.1,188.2  "
  })), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M309.2,136.9h-16.7c-2.1,0-3.8-1.7-3.8-3.8l0,0c0-2.1,1.7-3.8,3.8-3.8h16.7c2.1,0,3.8,1.7,3.8,3.8l0,0 C313,135.2,311.3,136.9,309.2,136.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M322.9,134.8H320c-0.9,0-1.7-0.8-1.7-1.7l0,0c0-0.9,0.8-1.7,1.7-1.7h2.9c0.9,0,1.7,0.8,1.7,1.7l0,0 C324.6,134,323.8,134.8,322.9,134.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M482.5,159.1H282.9c-1.7,0-3-1.4-3-3.1l1.3-31.1c0.1-1.6,1.4-2.8,3-2.8h197c1.6,0,2.9,1.3,3,2.8l1.3,31.1 C485.5,157.7,484.2,159.1,482.5,159.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M559.5,406v10H546c0,0-1.9-4,4.5-5.6l0.9-4.5h8.1V406z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M535.8,406v10h-13.4c0,0,0.6-3.9,4.5-5.6l1.3-4.5h7.6L535.8,406L535.8,406z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M556.5,249.5c0,0,2.6,31.6,2.6,56.6c0.1,25,1.6,102.1,1.6,102.1h-10.1c0,0-10.4-67.2-14.2-83.3 c-3.8-16-13.6-75-13.6-75L556.5,249.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M539.8,279.4c0,0-4.4,47.7-4.8,55.1c-0.4,7.5,1.2,73.5,1.2,73.5s-9.4,0.3-9.4,0s-12.9-68.1-14.1-86.5 c-0.7-11-3.3-16.9-4.3-27.5c-0.7-7.2,0.1-21.4,0-22.6c-0.3-6.2,3.1-16.6,3.1-16.6l16.7-1.6L539.8,279.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M451.2,146.6c0,0-3.3-4.9-4.1-5.9c-0.7-1-3.2-4.3-4.2-4.7c-1.1-0.4-4.3,0.2-4.6,0.6 c-2.3,3.2-3.1,3.8-2.7,6s2.5,2.5,4,3.7c1.4,1.2,2,1.8,3.9,2.2c1.8,0.4,3.8,2,4,2.2L451.2,146.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M520.9,139.5c-2.1,1.3-3,4.8-3,4.8s-0.8,4-1.3,7.1s-3.1,5.5-2.8,6.3s2.1,0.8,2.1,2c0,1.1,0.4,4.4,0.4,6.6 c0,2.2,2.2,2.6,4.3,2.8s4.8,0.7,5.3,1.7s1,10.9,1,10.9l15.4-6c0,0-1.6-5-1.5-9.3c0.2-4.3,0.4-9.5,0.4-9.5s-0.9-9.4-6.6-13.1 C528.8,139.9,520.9,139.5,520.9,139.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M525.1,144.4c-1.5-0.2-3.4-1.5-5.6-1.5c-1.4,0-1.5-3.7,0.9-6.3c1.4-1.5,3.1-0.5,4.8-1.2 c4.7-2,13.6-2,16.6,4.7c0,0,5.9,2.5,6.2,7.2s-0.7,6.5-3,9.7s-4.1,9.4-4.1,9.4s-2.8,0.2-5.5,0s-4.1-5.1-5.2-7l-5.7-2l-1.8,0.1 c0,0-0.4-4.5-0.2-7.2C522.6,147.4,525.1,144.4,525.1,144.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M540.8,173.7c0,0-6.6,1.2-9.8,1.6c-1.4,0.2-3,0.2-4.4,0.2c-2,0-10.3,1.9-10.3,1.9s-7.2,9.1-7.5,19.5 c-0.4,10.3,0.9,58.7,0.5,62.2c0,0,3.2,7.5,26.1,6.9c13.3-0.4,22.9-4.2,22.9-4.2s0.7-29,0.8-38.1c0.3-36-1.5-43.2-6-47.7 C549.6,172.3,540.8,173.7,540.8,173.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M521,177.6c5-0.2,11.8,17-5.7,17.8c-14,0.6-48-16.9-48-16.9l-23.2-28.7c0,0,3.1-4.6,6.5-5.4l23.7,22 C474.2,166.4,508.9,178,521,177.6z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M508.7,223.4c0.6,4.9,1.9,4.7,3,4.6c6.1-0.1,10.6-18.1,11.1-27.1c1-16.8-2.7-24.4-2.7-24.4l4.5-0.8 c0,0,0,4.5,5.8,7.8c3.5,2,14.8,1.5,15.4-3.5c0.6-5-2.6-6.6-2.6-6.6h4.7c0,0,4.7,5,8.2,15.1c3.8,11.2,2.8,17.6,3.3,21.1 s0.4,62.6-0.3,67s-0.4,12.5-0.4,12.5l-50.3-17.6c0,0-1-13.1-1-21.9C507.5,234.8,508.7,223.4,508.7,223.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M517.9,144.3c0,0-8.7-4.3-8.9-10.1c-0.2-5.9,10.2-6.7,13.7-5.3c4.6,1.8,11,8.8,11,8.8L517.9,144.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M517.9,144.3c0,0,3.2,7.4,10.7,11.7c7.1,4.1,15.1,4.6,15.1,4.6s7-4.9,5.7-13.7s-9.2-15.4-20.7-13.4 C520.3,135,517.9,144.3,517.9,144.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M521.4,155.4c0,0,2.4,0.1,2.9,0c0.6-0.1,1.4-2.1,3-2.3c1.5-0.2,2.7,0,2.9,1.9s-0.5,2.8-2.1,4.6 c-1.4,1.5-1.9,3.2-4,3s-1.7-2.7-1.7-3.1c0-0.4-1.4-1.6-1.4-1.6L521.4,155.4z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "524.6,400 537.1,400 536.3,408.1 526.8,408.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "548.8,400 561.5,400 560.7,408.1 550.6,408.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "543.8,281.5 545.3,299.2 555.2,298.8 555.8,281.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "515.3,281.5 516.8,299.2 526.7,298.8 528.3,281.1  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M633.8,424.2c0,0-2.4-34.7,3.1-42.6c4.6-6.7,1.4-16.8,0.3-19.7c-0.2-0.5-0.2-1.1,0.1-1.6 c1.2-2.1,4.1-8.5,2.5-14c-1.5-5-4.7-7.9-6.3-9.1c-0.5-0.4-0.7-1-0.6-1.7c0.7-4.9,2.3-24.4-13.9-28.9c-0.6-0.2-1.2,0.2-1.5,0.8 c-1,1.9-2.9,6.5-3.6,13.3c-0.7,7,2.1,13.2,3.4,15.8c0.4,0.7,0.3,1.6-0.2,2.2c-1.7,1.7-4.7,5.9-3.3,11.5s3.1,8.8,3.8,10.1 c0.3,0.4,0.3,1,0.2,1.5c-0.7,2.5-2.3,10.5,0.2,18c3.1,9.1,14.7,45.2,14,62C631.9,441.7,632.9,437.5,633.8,424.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M621,315c0,0,8.7,26.8,12.8,105.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M631.6,413.5c0,0,2-28-2.6-36.4c-3.9-7.2,0.3-16.9,1.7-19.7c0.2-0.5,0.3-1.1,0.1-1.6 c-0.9-2.3-3.2-8.9-1.1-14.2c2-4.9,5.5-7.4,7.2-8.4c0.5-0.3,0.8-0.9,0.8-1.6c-0.2-4.9,0.1-24.5,16.8-27.3c0.6-0.1,1.2,0.3,1.5,1 c0.8,2,2.2,6.8,2.2,13.6c0,7.1-3.4,13-5,15.4c-0.4,0.7-0.4,1.6,0.1,2.2c1.5,1.9,4.1,6.3,2.1,11.8s-4,8.5-4.9,9.7 c-0.3,0.4-0.4,0.9-0.3,1.4c0.4,2.6,1.2,10.7-2.1,17.9c-4,8.8-12.1,41.8-13.1,58.5C634.9,435.9,631.2,426.9,631.6,413.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M647.1,358c10.1-18.6,23-22.3,27.2-23c0.8-0.1,1.5,0.5,1.6,1.5c0.3,2.5,0.1,7.4-4.5,11.3l-4.9,4.2 c-0.7,0.6-0.8,1.8-0.2,2.6c1.7,2.1,3.7,6.4-2.7,12.3c-5.8,5.3-9.1,8.8-10.7,10.5c-0.6,0.7-0.6,1.9,0,2.5c1.8,1.9,4.5,5.9,0,10.8 c-6.2,6.8-16.7,34.7-17.9,46.9C635,437.6,635,380.5,647.1,358z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M620.3,342.7c-10.1-18.6-23-22.3-27.2-23c-0.8-0.1-1.5,0.5-1.6,1.5c-0.3,2.5-0.1,7.4,4.5,11.3l4.9,4.2 c0.7,0.6,0.8,1.8,0.2,2.6c-1.7,2.1-3.7,6.4,2.7,12.3c5.8,5.3,9.1,8.8,10.7,10.5c0.6,0.7,0.6,1.9,0,2.5c-1.8,1.9-4.5,5.9,0,10.8 c6.2,6.8,16.7,34.7,17.9,46.9C632.4,422.2,632.5,365.1,620.3,342.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M632.1,420.3c-6.1-17-8.3-31-16.5-47.2c-4.8-9.6-10.4-28.2-26.7-39.3c-1-0.7-2.2,0.2-2.2,1.6 c0.1,5.3,0.9,16.5,4.9,21.4c2.1,2.6,3.4,4.1,4.2,5c0.6,0.7,0.6,1.8,0,2.4c-1.7,2-3.9,6.5,2.3,12.6c5.7,5.6,9,8.7,10.7,10.3 c0.6,0.6,0.7,1.7,0.2,2.4c-1.4,2.1-3.2,6.4,1.7,10.6c10.1,8.7,18.6,22.7,24.1,37.4L632.1,420.3z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M633.8,433.3C630.5,362,652.2,312,652.2,312"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M590.8,340.2c0,0,34.7,51.2,42.4,91.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M622.7,449.9h18.6c4.1,0,7.6-3,8.1-7.1l4.2-31.1h-43.2l4.2,31.1C615.1,446.9,618.5,449.9,622.7,449.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M650.6,433.6l-1.2,9.2c-0.5,4.1-4,7.1-8.1,7.1h-18.6c-4.1,0-7.6-3-8.1-7.1l-1.2-9.2H650.6z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 607.4,
    y: 404.3,
    className: "st20",
    width: 48.8,
    height: 7.2
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomepageIllustration);
export default __webpack_public_path__ + "static/media/homepage_illustration.2f50dd983810d04697835c6b698554ff.svg";
export { ForwardRef as ReactComponent };